let id = 1;
const randomId = () => {
	id++;
	return id;
};

export const navbarItems = [
	{
		id: randomId(),
		link: "/",
		icon: "fas fa-home",
		title: "لوحة التحكم",
		children: [],
	},
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-users-cog",
		title: "المشرفين",
		children: [
			{
				id: randomId(),
				title: "جميع المشرفين",
				link: "/moderators/index",
			},
			{
				id: randomId(),
				title: "اضافة مشرف جديد",
				link: "/moderators/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-desktop",
		title: "تحكم الخلفيات",
		children: [
			{
				id: randomId(),
				title: "خلفية العناوين",
				link: "/backgrounds/breadcrumbs",
			},
			{
				id: randomId(),
				title: "خلفية المنتجات",
				link: "/backgrounds/services",
			},
			{
				id: randomId(),
				title: "خلفية اراء العملاء",
				link: "/backgrounds/testmonials",
			},
			{
				id: randomId(),
				title: "خلفية اتصل بنا",
				link: "/backgrounds/contactUs",
			},
		],
	},

	{
		id: randomId(),
		link: "/projects/index",
		icon: "fas fa-solid fa-building",
		title: "المشاريع",
		children: [
			{
				id: randomId(),
				title: "جميع المشاريع",
				link: "/projects/index",
			},
			{
				id: randomId(),
				title: "اضافة مشروع جديدة",
				link: "/projects/create",
			},
			{
				id: randomId(),
				title: "جميع الفئة",
				link: "/category/index",
			},
			{
				id: randomId(),
				title: "اضافة الفئة جديدة",
				link: "/category/create",
			},
		],
	},

	{
		id: randomId(),
		link: "/statistics/index",
		icon: "fas fa-chart-bar",
		title: "الاحصائيات",
		children: [
			{
				id: randomId(),
				title: "جميع الاحصائيات",
				link: "/statistics/index",
			},
			{
				id: randomId(),
				title: "اضافة احصائية جديدة",
				link: "/statistics/create",
			},
		],
	},
	{
		id: randomId(),
		// link: "/designs/index",
		icon: "fas fa-desktop",
		title: "التصاميم",
		children: [
			{
				id: randomId(),
				title: "صور التصاميم",
				link: "/designs/images",
			},
			{
				id: randomId(),
				title: "فيديوهات التصاميم",
				link: "/designs/videos",
			},
			{
				id: randomId(),
				title: "أضافة تصميم جديد",
				link: "/designs/createDesign",
			},
		],
	},
	{
		id: randomId(),
		link: "/services/index",
		icon: "fas fa-solid fa-laptop-house",
		title: "المنتجات",
		children: [
			{
				id: randomId(),
				title: "جميع المنتجات",
				link: "/services/index",
			},
			{
				id: randomId(),
				title: "اضافة منتج جديدة",
				link: "/services/create",
			},
			{
				id: randomId(),
				title: "تصنيفات المنتجات",
				link: "/services/categories/index",
			},
			{
				id: randomId(),
				title: "اضافة تصنيف جديد",
				link: "/services/categories/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/partners",
		title: "شركاء النجاح",
		icon: "fas fa-solid fa-people-carry",
		children: [
			{
				id: randomId(),
				title: "  جميع شركاء النجاح",
				link: "/partners/index",
			},
			{
				id: randomId(),
				title: " شريك نجاح جديد",
				link: "/partners/create",
			},
		],
	},
	// {
	// 	id: randomId(),
	// 	link: "/teamMembers/index",
	// 	icon: "fas fa-users",
	// 	title: "فريق العمل",
	// 	children: [
	// 		{
	// 			id: randomId(),
	// 			title: "أعضاء الفريق",
	// 			link: "/teamMembers/index",
	// 		},
	// 	],
	// },
	// {
	// 	id: randomId(),
	// 	link: "/licens/index",
	// 	icon: "fas fa-users",
	// 	title: "الاعتمادات والتراخيص",
	// 	children: [
	// 		{
	// 			id: randomId(),
	// 			title: " جميع التراخيص",
	// 			link: "/licens/index",
	// 		},
	// 	],
	// },
	{
		id: randomId(),
		link: "/faqs/index",
		icon: "fas fa-comments",
		title: "الاسئلة الشائعة",
		children: [
			{
				id: randomId(),
				title: "جميع الاسئلة الشائعة",
				link: "/faqs/index",
			},
			{
				id: randomId(),
				title: "اضافة سؤال جديد  ",
				link: "/faqs/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/comments/index",
		icon: "fas fa-comments",
		title: "اراء العملاء",
		children: [
			{
				id: randomId(),
				title: "جميع الاراء",
				link: "/comments/index",
			},
			{
				id: randomId(),
				title: "اضافة رائ جديدة",
				link: "/comments/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/blogs/index",
		icon: "fas fa-blog",
		title: "المدونة",
		children: [
			{
				id: randomId(),
				title: "جميع المدونات",
				link: "/blogs/index",
			},
			{
				id: randomId(),
				title: "اضافة مدونة جديدة",
				link: "/blogs/create",
			},
			{
				id: randomId(),
				title: "جميع فئات المدونات",
				link: "/blogs/categories/index",
			},
			{
				id: randomId(),
				title: "اضافة فئة مدونة جديدة",
				link: "/blogs/categories/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/orders/index",
		icon: "fas fa-envelope",
		title: "الطلبات",
		children: [],
	},
	// {
	// 	id: randomId(),
	// 	link: "/hiringRequests/index",
	// 	icon: "fas fa-briefcase",
	// 	title: "طلبات التوظيف",
	// 	children: [],
	// },
	{
		id: randomId(),
		link: "/social",
		title: "وسائل التواصل",
		icon: "fas fa-id-card",
		children: [
			// {
			// 	id: randomId(),
			// 	title: " انواع التواصل",
			// 	link: "/social/socialType/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "اضافة نوع تواصل",
			// 	link: "/social/socialType/create",
			// },
			{
				id: randomId(),
				title: " روابط التواصل",
				link: "/social/links/index",
			},
			{
				id: randomId(),
				title: "اضافة رابط تواصل",
				link: "/social/links/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/siteinfo",
		icon: "far fa-address-card",
		title: " بيانات الموقع ",
		children: [
			{
				id: randomId(),
				title: "لافتات الترحيب",
				link: "/siteinfo/heroSection/index",
			},
			{
				id: randomId(),
				title: "عن الشركة",
				link: "/siteinfo/aboutUs/show/about-us",
			},

			// {
			// 	id: randomId(),
			// 	title: "البيانات الاضافيه",
			// 	link: "/aboutPage/sideinfo/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "المميزات",
			// 	link: "/aboutPage/advantages/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الاحصائيات",
			// 	link: "/aboutPage/statistics/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الأسئله الشائعه",
			// 	link: "/aboutPage/questions/index",
			// },
		],
	},
];
